/** Pure helpers for the operator interview kickoff — kept out of the page component so they
 * stay trivially unit-testable (no React / rpc module graph). */

/** A kebab-case slug seed for the SOP name, derived from the kickoff instruction. */
export function slugify(text: string): string {
  return text
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 60);
}

/** Fold the optional intake answers into the instruction so the agent captures intent (not just
 * clicks): the trigger, the success condition, and what varies each run. Blank answers are omitted. */
export function composeInstruction(parts: {
  instruction: string;
  trigger: string;
  successCondition: string;
  variables: string;
}): string {
  const lines = [parts.instruction.trim()];
  if (parts.trigger.trim()) lines.push(`Trigger: ${parts.trigger.trim()}`);
  if (parts.successCondition.trim())
    lines.push(`Success when: ${parts.successCondition.trim()}`);
  if (parts.variables.trim())
    lines.push(`Varies each run: ${parts.variables.trim()}`);
  return lines.join('\n');
}
